import _ from 'lodash';

/* @ngInject */
export default function SessionService($http, $window, appConfig) {
  const service = this;

  // public function
  service.renew = renew;

  function renew() {
    return $http.get(`${appConfig.apiBaseUrl}/admin/config`, { withCredentials: true })
      .then((response) => {

        // eslint-disable-next-line no-magic-numbers
        if (response.httpStatus === 307 || _.get(response, 'data.user.kind') === 'anonymous') {

          const fullAppUrl = $window.location.href;
          const loginUrl = `${appConfig.apiBaseUrl}/account/login/`;
          const redirectUrl = _.get(response, 'data.extraErrorInfo.redirectUrl',
            _.get(response, 'extraErrorInfo.redirectUrl', loginUrl));
          $window.location = `${redirectUrl}?redirectUrl=${encodeURIComponent(fullAppUrl)}`;
          return;
        }

        _.merge(appConfig, response.data);

      }) // If there's an error getting the configuration, show a very basic error message
      .catch((res) => {

        // eslint-disable-next-line no-magic-numbers
        const httpStatus = _.get(res, 'status', _.get(res, 'httpStatus', 500));
        const errorCode = _.get(res, 'extraErrorInfo.code', _.get(res, 'data.extraErrorInfo.code', 0));
        const encodedFullAppUrl = encodeURIComponent($window.location.href);

        // eslint-disable-next-line no-magic-numbers
        if (httpStatus === 307 || (errorCode >= 1000 && errorCode <= 1004)) {
          const loginUrl = `${appConfig.apiBaseUrl}/account/login/`;
          const redirectUrl = _.get(res, 'data.extraErrorInfo.redirectUrl',
            _.get(res, 'extraErrorInfo.redirectUrl', loginUrl));
          $window.location = `${redirectUrl}?redirectUrl=${encodedFullAppUrl}`;
          return;
        }

        const errorMessage = httpStatus === -1 ?
          'Server or connection unavailable' :
          res.statusText || res.message;

        // Something unexpected has happened
        $window.location = `${appConfig.apiBaseUrl}/account/login?redirectUrl=${encodedFullAppUrl}`;
        throw new Error(errorMessage);

      });

  }
}
